import { DEBUG_LOG_ERROR } from "./fhtGlobalEnv";

const ex = window.exceptionless;
if (!ex) throw new Error("window.exceptionless falsy");
//see https://www.npmjs.com/package/exceptionless
const serverUrl = "https://exceptionless.fht360.cn";
const apiKey = '9CKhcMFiJiQm6ZRRJxa6ZaehOZlll8oAzyscgAGc';

const client = new ex.ExceptionlessClient({
	apiKey,
	serverUrl,
	submissionBatchSize: DEBUG_LOG_ERROR ? 1 : 100
});

export const exceptionless = client;

